import angular from 'angular';

angular.module('checkout').directive(
    'cartSummaryItems', [
        '$sce',
        'orderMgr',
        function (
            $sce,
            orderMgr
        ) {
            function link(scope) {
            }

            return {
                link: link,
                restrict: 'E', // element name
                scope: {
                    propsOrderItems: '=orderItems',
                },
                template: `
<style type="text/css">
.reliv-cart-summary > a:hover .reliv-cart-summary-items .pop-out {
    display: block;
}

.reliv-cart-summary-items .pop-out {
    display: none;
    position: absolute;
    right: 0;
    width: 360px;
    padding: 15px;
    background-color: white;
    border: solid 1px #CCCCCC;
    z-index: 10000;
}

.reliv-cart-summary-items .pop-out .item {
    clear: both;
    padding-bottom: 15px;
    overflow: hidden;
    display: block;
}

.reliv-cart-summary-items .pop-out .item .item-image {
    float: left;
    width: 50px;
    margin-right: 10px;
}

.reliv-cart-summary-items .pop-out .item .item-image span,
.reliv-cart-summary-items .pop-out .item .item-image img {
    max-width: 50px;
    max-height: 60px;
}

.reliv-cart-summary-items .pop-out .item .item-description {
    float: left;
    max-width: 264px;
    margin-bottom: .5em;
}

.reliv-cart-summary-items .pop-out .item .item-qty div {
    float: left;
}

.reliv-cart-summary-items .pop-out .view-cart {
    width: 100%;
    text-align: center;
    text-transform: uppercase;
}
</style>
<div class="reliv-cart-summary-items visible-sm visible-md visible-lg">
    <div class="pop-out" ng-show="propsOrderItems">

        <a ng-repeat="item in propsOrderItems" class="item" href="/p/{{item.detailPage}}">

            <div class="item-image">
                <img ng-show="item.sku.images[0].thumbSrc"
                     class=""
                     ng-src="{{item.sku.images[0].thumbSrc}}"
                >
                <span class="" ng-hide="item.sku.images[0].thumbSrc">&nbsp;</span>
            </div>

            <div class="item-description">
                <div class="item-name">{{item.name}}</div>
                <div class="item-qty">
                    <span class="">{{'Quantity' | translate}}</span>:&nbsp;<span class="">{{item.qty}}</span>
                </div>
            </div>
        </a>

        <span ng-hide="propsOrderItems.length">{{'There are no items in your cart' | translate}}</span>

        <a class="button btn btn-primary view-cart" href="/cart#/items" ng-show="propsOrderItems.length">
            {{'View Cart' | translate}}
        </a>
    </div>
</div>
                `,
            };
        },
    ]
);
